module.exports = __webpack_public_path__ + "static/media/2.3304e2db.png";